import * as types from "./UserRights.actionTypes"

let init = {
    userRightsData:{}
}


export const userRightsReducer = (state=init,{type,payload})=>{
 switch(type){
    case types.USER_RIGHTS :{
        return {
             ...state, userRightsData:payload
        }
    }
    default :{
       return state
    }
 }

}